export enum ApplyTo {
  All = 'all',
  Selected = 'selected'
}
